export const normalizeForSearch = (input) => input.replaceAll(/\s+/g, ' ').toLowerCase();
export const searchNormalized = (input, search) => normalizeForSearch(input).includes(normalizeForSearch(search));
